import { Box, Button, HStack } from "@chakra-ui/react";
import { useFlags } from "flagsmith/react";
import React from "react";
import { EmptyState } from "src/components/EmptyState";
import { WithUserPermissions } from "src/components/Permissions/WithUserPermissions";
import { useSendMessage } from "src/hooks/useSendMessage";
import NoMessagesSvg from "src/images/no-messages.svg?react";
import { getGuardians, isEligibleForMessaging } from "src/services/person";
import * as GQL from "src/types/graphql";

interface NoMessagesProps {
  form: GQL.GetFormViewById_form_by_pk;
  formTemplate: GQL.FormTemplateFragment;
}

export const NoMessages: React.FC<NoMessagesProps> = ({
  form,
  formTemplate,
}) => {
  const flags = useFlags(["unverified-communications"]);
  const { handleSendMessage } = useSendMessage(formTemplate.id);
  const formParents = getGuardians(form.person);

  const isUnverifiedCommsEnabledForOrg =
    flags["unverified-communications"].enabled;

  const isEligibleForMessage = formParents.some((parent) =>
    isEligibleForMessaging(parent, isUnverifiedCommsEnabledForOrg)
  );

  return (
    <Box display="grid" minHeight="50vh" placeContent="center">
      <EmptyState
        description="There are no messages for this form response"
        heading=""
        Svg={NoMessagesSvg}
      >
        <HStack>
          <WithUserPermissions permissions={["message:create"]}>
            {isEligibleForMessage && (
              <Button
                onClick={() => handleSendMessage([form.id])}
                variant="outline"
              >
                Send new message
              </Button>
            )}
          </WithUserPermissions>
        </HStack>
      </EmptyState>
    </Box>
  );
};
